import { Typography } from '@ethings/ui-toolkit';
import { FC, useEffect, useState, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../components';
import { HEIGHT_TO_CLOSE_DRAWER, WIDTH_TO_CLOSE_DRAWER } from '../../../constants';
import { useResponsiveText } from '../../../hooks';
import { innerText } from '../../../util';
import { DrawerSize, TwoWayControllerProps } from '../event-history.types';
import { TwoWayCollapseView } from './two-way-collapse-view';

export const TwoWayCollapseController: FC<TwoWayControllerProps> = ({ bottomDrawerContent, isBottomDrawerOpen, topDrawerContent }): JSX.Element => {
  const { t } = useTranslation(['common']);
  const [bottomDrawerExited, setBottomDrawerExited] = useState(true);
  const [bottomDrawerHeight, setBottomDrawerHeight] = useState<DrawerSize>(DrawerSize.CLOSED);
  const closedDrawerSize = isBottomDrawerOpen === undefined ? DrawerSize.CLOSED : 0;
  const mapText = t('common:common.labels.map');

  const mapStyle = useResponsiveText('1rem', innerText(mapText).length, {
    minFontSize: '0.875rem',
    maxFontSize: '1rem',
    textLengthThreshold: 15,
  });

  const renderTopDrawerHeaderIcon = (): JSX.Element => <Icon icon="MapIcon" />;
  const renderTopDrawerHeaderTitle = (): JSX.Element => <Typography style={mapStyle}>{mapText}</Typography>;

  useEffect(() => {
    const closeDrawer = (): void => {
      if (window.innerWidth > WIDTH_TO_CLOSE_DRAWER && window.innerHeight > HEIGHT_TO_CLOSE_DRAWER) return;
      setBottomDrawerHeight(DrawerSize.CLOSED);
    };

    window.addEventListener('resize', closeDrawer);

    return () => window.removeEventListener('resize', closeDrawer);
  }, []);

  useEffect(() => {
    if (isBottomDrawerOpen === undefined) return;
    setBottomDrawerHeight(isBottomDrawerOpen ? DrawerSize.OPEN : DrawerSize.CLOSED);
  }, [isBottomDrawerOpen]);

  return (
    <TwoWayCollapseView
      bottomDrawerContent={bottomDrawerContent}
      bottomDrawerExited={bottomDrawerExited}
      bottomDrawerHeight={bottomDrawerHeight}
      closedDrawerSize={closedDrawerSize}
      renderTopDrawerHeaderIcon={renderTopDrawerHeaderIcon}
      renderTopDrawerHeaderTitle={renderTopDrawerHeaderTitle}
      setBottomDrawerExited={setBottomDrawerExited}
      setBottomDrawerHeight={setBottomDrawerHeight}
      topDrawerContent={topDrawerContent}
    />
  );
};
